import { Search } from '@casumo/dojo-react-icons';
import classNames from 'classnames';
import { memo } from 'react';
import { useRegistrationStore } from '../store/store.ts';
import { TEnterAddressManuallyTextField } from '../types/types.ts';
import { TEST_ID } from '../utils/constants.ts';

export const EnterAddressManuallyText = ({
  label,
  link,
  toggleEnterAddressManually,
  styles,
}: TEnterAddressManuallyTextField) => {
  const { setCondition , setIsAddressSearchOpen } = useRegistrationStore();

  return (
    <div className="flex justify-center">
      <p className={classNames('flex items-center text-body-sm text-center', styles?.label)}>
        {label}
      </p>
      &nbsp;
      <a className={classNames('flex items-center text-body-sm cursor-pointer text-purple-60 text-center',
        styles?.link)}
      onClick={() => {
        if (!toggleEnterAddressManually) {
          setCondition('enterAddressManually', false);
          setIsAddressSearchOpen(true);
        } else {
          setCondition('enterAddressManually', toggleEnterAddressManually);
        }
          
      }}
      data-testid={TEST_ID.TOGGLE + 'addressSearchType'}
      >
        {!toggleEnterAddressManually ? (
          <>
            <Search /> &nbsp; {link}
          </>
        ) : (
          link
        )}
      </a>
    </div>

  );
};

const Memoized = memo(EnterAddressManuallyText);
Memoized.displayName = 'EnterAddressManuallyText';

export default Memoized;
